import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

type LinkItem = {
  label: string;
  to: string;
  variant?: 'text' | 'outlined' | 'contained';
};

interface FeatureLockModalProps {
  serviceName: string;
  description?: string;
  suggestions?: LinkItem[];
}

const FeatureLockModal: React.FC<FeatureLockModalProps> = ({
  serviceName,
  description,
  suggestions = []
}) => {
  const desc = description || `Tato sekce (${serviceName}) je nyní uzamčená a připravujeme ji k uvedení. Mezitím prosím vyzkoušejte jiné dostupné funkce.`;

  return (
    <Dialog open aria-labelledby="feature-locked-title" fullWidth maxWidth="sm">
      <DialogTitle id="feature-locked-title" sx={{ fontWeight: 800 }}>
        {serviceName} – připravujeme
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ color: '#444' }}>
          {desc}
        </Typography>
        {suggestions.length > 0 && (
          <Box sx={{ mt: 3, display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
            {suggestions.map((item, idx) => (
              <Button
                key={`${item.to}-${idx}`}
                component={RouterLink}
                to={item.to}
                variant={item.variant || (idx === 0 ? 'contained' : 'outlined')}
                color={idx === 0 ? 'primary' : 'inherit'}
              >
                {item.label}
              </Button>
            ))}
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button component={RouterLink} to="/dashboard" color="inherit">
          Zpět na dashboard
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FeatureLockModal;

